import axios from "axios";
import MomentLocaleUtils, {formatDate, parseDate} from 'react-day-picker/moment';
import DayPickerInput from "react-day-picker/DayPickerInput";
import React from "react";

export function handleDayChange(selectedDay, modifiers, dayPickerInput) {
    const input = dayPickerInput.getInput();
    this.setState({
        selectedDay,
        isEmpty: !input.value.trim(),
        isValidDay: typeof selectedDay !== 'undefined',
        isDisabled: modifiers.disabled === true
    });
}

export function searchData(day){
    const { apiSummary } = this.state;
    const searchDay = formatDate(day, 'YYYYMMDD');
    const inputDay =  formatDate(day, 'DD/MM/YYYY');
    const payload = {yyyymmdd: searchDay}
  /*
    const headers = {
        'Authorization': 'Bearer my-token',
        'Access-Control-Allow-Origin': true,
        'My-Custom-Header': 'foobar'
    };

   */
    this.setState({isLoading: true})
    axios.post(apiSummary, payload)
        .then(response => !!response.data
            ? this.setState({treeValues: response .data, inputDay: inputDay, errorMessage:'',isLoading: false})
            : this.setState({ treeValues: response.data,inputDay: inputDay, errorMessage: 'Không tìm thấy dữ liệu báo cáo !',isLoading: false})
        )
        .catch(error => {
            this.setState({ errorMessage: error.message,isLoading: false });
            console.error('There was an error!', error);
        })
}

export function search(){
    const {isValidDay, selectedDay} = this.state;
    if (isValidDay) {
        this.searchData(selectedDay);
    }
}
/*
function waitSeconds(iMilliSeconds) {
    var counter= 0
        , start = new Date().getTime()
        , end = 0;
    while (counter < iMilliSeconds) {
        end = new Date().getTime();
        counter = end - start;
    }
}

 */

export function renderSearchForm(selectedDay){
    return (
        <div className={'ml-5 mb-2'}>
            <span className={'font-weight-bold'}>Ngày báo cáo:</span> &nbsp;
            <DayPickerInput
                value={selectedDay}
                onDayChange={this.handleDayChange}
                selectedDay={this.state.selectedDay}
                formatDate={formatDate}
                parseDate={parseDate}
                format="DD/MM/YYYY"
                placeholder='DD/MM/YYYY'
                dayPickerProps={{
                    selectedDays: selectedDay,
                    locale: 'vi-VN',
                    localeUtils: MomentLocaleUtils,
                }}
                inputProps={{ className: 'form-control' }}
            /> &nbsp;
            <button type='button' className={'btn btn-primary mb-2'} onClick={this.search} >Xem báo cáo</button>
        </div>
    )
}

export function AGB_renderSearchForm(selectedDay, reportType){
    return (
        <div className={'ml-5 mb-2'}>
            <span className={'font-weight-bold'}>Ngày báo cáo:</span> &nbsp;
            <DayPickerInput
                value={selectedDay}
                onDayChange={this.handleDayChange}
                selectedDay={this.state.selectedDay}
                formatDate={formatDate}
                parseDate={parseDate}
                format="DD/MM/YYYY"
                placeholder='DD/MM/YYYY'
                dayPickerProps={{
                    selectedDays: selectedDay,
                    locale: 'vi-VN',
                    localeUtils: MomentLocaleUtils,
                }}
                inputProps={{ className: 'form-control' }}
            />
            &nbsp;
            <input type="radio"
                   className={'ml-2'}
                   name="reportType"
                   id="referral"
                   value="Giới thiệu"
                   checked={reportType === 'Giới thiệu'}
                   onChange={this.handleReportTypeChange} />
            &nbsp;
            <label>Giới thiệu</label>
            <input type="radio"
                   className={'ml-2'}
                   name="reportType"
                   id="directSale"
                   value="Bán trực tiếp"
                   checked={reportType === 'Bán trực tiếp'}
                   onChange={this.handleReportTypeChange} />
            &nbsp;
            <label>Bán trực tiếp</label>

            <input type="radio"
                   className={'ml-2'}
                   name="reportType"
                   id="all"
                   value="Tất cả"
                   checked={reportType === 'Tất cả'}
                   onChange={this.handleReportTypeChange} />
            &nbsp;
            <label>Tất cả</label>
            &nbsp;
            <button type='button' className={'btn btn-primary ml-2 mb-2'} onClick={this.AGB_search} >Xem báo cáo</button>
        </div>
    )
}
export function AGB_search(){
    const {isValidDay, selectedDay, reportType} = this.state;
    if (isValidDay) {
        this.AGB_searchData(selectedDay, reportType);
    }
}

export function AGB_searchData(day, reportType){
    const { apiSummaryDirectSale, apiSummaryReferral, apiSummaryAll } = this.state;
    const searchDay = formatDate(day, 'YYYYMMDD');
    const inputDay =  formatDate(day, 'DD/MM/YYYY');
    const payload = {yyyymmdd: searchDay}
    this.setState({isLoading: true});
    let apiSummary = undefined;
    if(reportType === 'Giới thiệu'){
        apiSummary = apiSummaryReferral;
    }
    if(reportType === 'Bán trực tiếp'){
        apiSummary = apiSummaryDirectSale;
    }
    if(reportType === 'Tất cả'){
        apiSummary = apiSummaryAll;
    }
    axios.post(apiSummary, payload)
        .then(response => !!response.data
            ? this.setState({treeValues: response .data, inputDay: inputDay, errorMessage:'',isLoading: false})
            : this.setState({ treeValues: response.data,inputDay: inputDay, errorMessage: 'Không tìm thấy dữ liệu báo cáo !',isLoading: false})
        )
        .catch(error => {
            this.setState({ errorMessage: error.message,isLoading: false });
            console.error('There was an error!', error);
        })
}